import { render, staticRenderFns } from "./ApprovalReference.vue?vue&type=template&id=641e9362&scoped=true&"
import script from "./ApprovalReference.vue?vue&type=script&lang=js&"
export * from "./ApprovalReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e9362",
  null
  
)

export default component.exports